module.exports = __webpack_public_path__ + "static/media/flower6.eb2a5be1.png";